import { render, staticRenderFns } from "./CurrentRecentManufacturerDetailsComponent.vue?vue&type=template&id=016a6cfc"
import script from "./CurrentRecentManufacturerDetailsComponent.vue?vue&type=script&lang=ts"
export * from "./CurrentRecentManufacturerDetailsComponent.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports